import useSWR from "swr";
import { CleanBeautyInfo, getCleanBeautyData } from "./cleanBeautyService";

type LoadDataStatus<DataType> = {
  status: "No Action" | "Loading" | "Error" | "Done";
  message?: string;
  data?: DataType;
};

function useCleanBeauty(
  ean: string,
  cleanBeautyBaseUrl: string,
): LoadDataStatus<CleanBeautyInfo> {
  const { data: cleanBeautyData, error } = useSWR(
    ean ? ean : null,
    () => getCleanBeautyData(ean, cleanBeautyBaseUrl),
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      revalidateOnReconnect: false,
      errorRetryCount: 1,
      errorRetryInterval: 500,
    },
  );
  if (!ean) {
    return { status: "No Action" };
  }
  if (error) {
    return {
      status: "Error",
      message: "Error loading clean beauty information",
    };
  }
  if (!cleanBeautyData) {
    return { status: "Loading" };
  }
  return { status: "Done", data: cleanBeautyData };
}

export { useCleanBeauty };
